import { Button, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { useForm } from "react-hook-form";

export const ExportedOrderList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
 const {register,handleSubmit,control} = useForm()


  const columns: IColumns[] = [
    {
      header: "sr.#",
      fieldName: "workLocationName",
      tooltip: true,
    },
    {
      header: "order#",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Guest",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Type",
      fieldName: "address",
      tooltip: true,
    },
    {
        header: "Status",
        fieldName: "address",
        tooltip: true,
      },
  ];

  const handleClick = (path: string) => {
    navigate(path);
  };
const onSubmit = async (data: any) => {
    console.log("onsubmit===>", data); // Perform any action with the submitted data here
  };
  return (
    <Grid container direction="column" sx={{ minHeight: '100vh' }}>
      {/* Header Section */}
      <Grid item>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ padding: 1 }}
        >
          <Typography variant="h6" sx={{ color: "#388E3C", fontWeight: "bold" }}>
            Exported Order List 
          </Typography>
          <IconButton>
            <WSIcons.CloseIcon
              sx={{ backgroundColor: "red", color: "white" }}
              onClick={() => handleClick("/callcenter")}
            />
          </IconButton>
        </Grid>
      </Grid>
      <Grid item sx={{ padding: 1 }}>
  <Grid container alignItems="center" justifyContent="space-between" >
    <Grid item xs={12} sm={2}>
      <Typography>Select File</Typography>
    </Grid>
    <Grid item xs={12} sm={8}>
      <WSTextField
        label={""}
        {...register("zip")}
        id="zip"
        name="zip"
        control={control}
        rules={{ required: false }}
      />
    </Grid>
    <Grid item xs={12} sm={1} sx={{ display: "flex", justifyContent: "center" }}>
      <WSIcons.SyncIcon />
    </Grid>
    <Grid item xs={12} sm={1} sx={{ display: "flex", }}>
      <WSIcons.SearchIcon />
    </Grid>
  </Grid>
</Grid>

      {/* DataGrid Section */}
      <Grid item sx={{ flex: 1, padding: 2 }}>
        <WSDataGrid
          id="itemGrid"
          title=""
          columns={columns}
        />
      </Grid>

      {/* Footer Section */}
      <Grid
        item
        sx={{
          backgroundColor: "#333",
          padding: "1rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
         <Grid item>
          <WSIcons.GTranslateIcon sx={{ color: "white" }} />
        </Grid>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "green",
            "&:hover": {
              backgroundColor: "#388e3c",
            },
          }}
          onClick={handleSubmit(onSubmit)}
        >
          Import
        </Button>
      </Grid>
    </Grid>
  );
});
